import { render, staticRenderFns } from "./niandu.vue?vue&type=template&id=e56c8ff8&scoped=true&"
import script from "./niandu.vue?vue&type=script&lang=js&"
export * from "./niandu.vue?vue&type=script&lang=js&"
import style0 from "./niandu.vue?vue&type=style&index=0&id=e56c8ff8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56c8ff8",
  null
  
)

export default component.exports